import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import Content, { HTMLContent } from '../components/Content'
import PreviewCompatibleImage from '../components/PreviewCompatibleImage'

export const ProductTemplate = ({ content, contentComponent, title, helmet, featuredimage }) => {
    const PostContent = contentComponent || Content

    return (
        <section className="section">
            {helmet || ''}
            <div className="container content">
                <div className="columns">
                    <div className="column is-7">
                        <h1 className="title">{title}</h1>
                        <PostContent content={content} />
                    </div>
                    <div className="column is-3">
                        <div className="featured-thumbnail" style={{ maxWidth: 300 }}>
                            <PreviewCompatibleImage
                                imageInfo={{
                                    image: featuredimage,
                                    alt: `featured image thumbnail for post ${title}`
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

ProductTemplate.propTypes = {
    content: PropTypes.node.isRequired,
    contentComponent: PropTypes.func,
    title: PropTypes.string,
    helmet: PropTypes.object
}

const ProductPage = ({ data }) => {
    const { markdownRemark: post } = data

    return (
        <Layout>
            <ProductTemplate
                content={post.html}
                contentComponent={HTMLContent}
                helmet={
                    <Helmet titleTemplate="%s">
                        <title>{`${post.frontmatter.title}`}</title>
                        {/* <meta name="description" content={`${post.frontmatter.description}`} /> */}
                    </Helmet>
                }
                title={post.frontmatter.title}
                featuredimage={post.frontmatter.featuredimage}
            />
        </Layout>
    )
}

ProductPage.propTypes = {
    data: PropTypes.shape({
        markdownRemark: PropTypes.object
    })
}

export default ProductPage

export const pageQuery = graphql`
    query ProductByID($id: String!) {
        markdownRemark(id: { eq: $id }) {
            id
            html
            frontmatter {
                date(formatString: "MMMM DD, YYYY")
                title
                featuredimage {
                    childImageSharp {
                        fluid(maxWidth: 300, quality: 100) {
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
            }
        }
    }
`
